import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyEndorsements.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const AgencyEndorsements = () => {
    
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([

        ])
        .then(() => {
        setIsLoading(false);
        })
        
    },[]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="agency-endorsements-main">
                    <Helmet><title>SMWW Sports Agency Endorsement & Sponsorship Opportunities</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="agency-endorsements-container">
                            <h1>SMWW Agency Endorsement &amp; Sponsorship Opportunities</h1>
                            <p>As your Agent, it is our job to turn your "brand"&nbsp;Into a revenue making machine. At SMWW Agency, we&nbsp;maximize your marketing opportunities. It is our goal to capitalize on any and every endorsement and or commercial opportunity at every level. With new Name, Image, and Likeness opportunities in the USA for college players, athlete marketing&nbsp;is&nbsp;changing.</p>
                            <h3><span>The SMWW Marketing Advantage</span></h3>
                            <div>
                                <p>As an educational entity, SMWW trains sport business executives&nbsp;in <a href="https://www.sportsmanagementworldwide.com/courses/athlete-marketing-and-branding-course">Athlete Marketing &amp; Branding</a>, and <a href="https://www.sportsmanagementworldwide.com/courses/name-image-likeness">Name, Image, and Likeness</a>.
                                 Simply put, we teach "state of the art"&nbsp;and "best business practices" to executives in all the major leagues. In addition, SMWW Fulfilment Center is located in Portland, Oregon, USA where we have unique relationships with <em>"our neighbors"</em>, Adidas, Under Armor, and NIKE, who are also headquartered in Portland.
                                 The SMWW Faculty includes executives from Nike, Adidas, and Lululemon. We offer sports career conferences with representatives from the top retailers, gaming companies, and card companies who are educating our students on the correct way to promote endorsements and sponsorships. In addition, current SMWW clients have contracts with the big name retailers.
                                 Our first job is to assist you with a successful job on the court, pitch, racetrack, field or rink,&nbsp;and secondary is to develop an integrated marketing strategy that could include the following elements:&nbsp;
                                </p>
                            </div>
                            <p><img alt="" className="imgfuli agency-endorsements-image" src="/basic/web/images/agent/endorce-basket.jpg" /></p>
                            <ul className="menu">
                                <li>Sponsorship</li>
                                <li>Product Endorsement</li>
                                <li>Speaking Engagements</li>
                                <li>Personal Appearances</li>
                                <li>Advertising Campaigns</li>
                                <li>Commercials and Radio</li>
                                <li>Licensing with trading card companies</li>
                                <li>Interactive Games</li>
                                <li>Athlete Modeling</li>
                                <li>Theatrical Roles</li>
                                <li>Celebrity Placement</li>
                                <li >Infomercials&nbsp;</li>
                            </ul>
                            <h2>&nbsp;</h2>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default AgencyEndorsements;